(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-locations"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sz-heritage')){
  customElements.define('sz-heritage',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      const places=Array.from(this.querySelectorAll('[data-place]'));
      const controls=Array.from(this.querySelectorAll('[data-location]'));
      const select=(id)=>{
        places.forEach(p=>p.hidden=p.dataset.place!==id);
        controls.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.location===id)));
      };
      if(places.length){select(places[0].dataset.place);this.classList.add('is-ready');}
      controls.forEach(b=>{
        b.addEventListener('click',()=>select(b.dataset.location));
        b.addEventListener('focus',()=>select(b.dataset.location));
        b.addEventListener('mouseenter',()=>{if(window.matchMedia('(hover:hover)').matches)select(b.dataset.location);});
      });
      this.addEventListener('shopify:block:select',e=>{if(e.detail.blockId)select(e.detail.blockId);});
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-new-arrivals-diverse"] && !Shopify.designMode) return;
  try {
    
function initializeSpeedzonePicks(){
 document.querySelectorAll('.szp:not([data-szp-ready])').forEach(section=>{
  section.dataset.szpReady='true';
  const cards=[...section.querySelectorAll('[data-szp-kind]')];
  section.querySelectorAll('[data-szp-filter]').forEach(button=>{
   button.setAttribute('aria-controls',section.querySelector('.szp-grid').id);
   button.addEventListener('click',()=>{
    section.querySelectorAll('[data-szp-filter]').forEach(other=>other.setAttribute('aria-pressed',String(other===button)));
    cards.forEach(card=>card.hidden=button.dataset.szpFilter!=='all'&&card.dataset.szpKind!==button.dataset.szpFilter);
    section.querySelector('.szp-status').textContent=cards.filter(card=>!card.hidden).length+' products shown';
   });
  });
 });
}
initializeSpeedzonePicks();
document.addEventListener('shopify:section:load',initializeSpeedzonePicks);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["speed-deals"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('speed-deals')) {
    customElements.define('speed-deals', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.preview === 'true' || this.hidden) return;
        this.end = Date.parse(this.dataset.ends);
        if (!Number.isFinite(this.end)) { this.hidden = true; return; }
        this.offset = Number(this.dataset.now) * 1000 - Date.now();
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
        this.onVisible = () => { if (!document.hidden) { this.tick(); this.syncTime(); } };
        document.addEventListener('visibilitychange', this.onVisible);
        this.syncTime();
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        clearTimeout(this.retry);
        document.removeEventListener('visibilitychange', this.onVisible);
        this.controller?.abort();
      }
      async syncTime() {
        try {
          const response = await fetch(this.dataset.root, { method: 'HEAD', cache: 'no-store' });
          const server = Date.parse(response.headers.get('Date'));
          if (Number.isFinite(server)) { this.offset = server - Date.now(); this.tick(); }
        } catch {}
      }
      tick() {
        if (this.expired) return;
        const seconds = Math.max(0, Math.floor((this.end - Date.now() - this.offset) / 1000));
        for (const [key, number] of [['hours', Math.floor(seconds / 3600)], ['minutes', Math.floor(seconds % 3600 / 60)], ['seconds', seconds % 60]]) {
          const target = this.querySelector('[data-' + key + ']');
          if (target) target.textContent = String(number).padStart(2, '0');
        }
        if (seconds === 0) {
          this.expired = true;
          clearInterval(this.timer);
          this.classList.add('sd--expired');
          this.querySelector('.sd__status').textContent = this.dataset.expired;
          this.refresh(0);
        }
      }
      async refresh(attempt) {
        if (!this.isConnected || attempt > 4) return;
        try {
          this.controller = new AbortController();
          const url = new URL(this.dataset.root, location.origin);
          url.searchParams.set('section_id', this.dataset.sectionId);
          url.searchParams.set('_speed_deals', String(Date.now()));
          const response = await fetch(url, { cache: 'no-store', signal: this.controller.signal });
          if (!response.ok) throw new Error('Unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const next = doc.querySelector('speed-deals');
          if (next && !next.hidden && Date.parse(next.dataset.ends) > Date.now() + this.offset) { this.replaceWith(next); return; }
        } catch {}
        this.retry = setTimeout(() => this.refresh(attempt + 1), 15000);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
